export default {
  computed: {
    productSearchLatestProductIds() {
      const ids = this.productSearch?.productIds;
      if (ids && ids.length > 0) {
        return ids.map((item) => item.productID);
      }
      return [];
    },
  },
};
